import React from "react";
import { NavLink } from "react-router-dom";
import { URLS } from "src/_config";
const HeaderMenu = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-transparent main_Navbar" data-bs-theme="dark">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" exact to={URLS.HOME}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to={URLS.EVENT.RODEO_DETAILS_LISTING}>
                Performances
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" exact to={URLS.EVENT.LINK_LEADERBOARD}>
                Leaderboard
              </NavLink>
            </li>
            <li className="nav-item d-none">
              <a className="nav-link" href="#">
                News
              </a>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" activeClassName="active" to="/cms/how-to-play">
                How to Play
              </NavLink>
            </li>
            <li className="nav-item d-none">
              <a className="nav-link nav_Red_Button" href="#">
                Fantasy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HeaderMenu;
